module.exports = require('./build/mediaelement-and-player.js');



//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/vasternorrlands-museum/public/wp-content/themes/murberget/node_modules/mediaelement/full.js
// module id = 174
// module chunks = 0